import { CandidateAiSummarySkill } from '../models/candidate-ai-summary.model';

export const canonicalCandidateSkillLevel = (value?: string): string => {
  switch ((value || '').trim().toUpperCase()) {
    case 'EXPERT':
    case 'ADVANCED':
      return 'Expert';
    case 'INTERMEDIATE':
      return 'Intermediate';
    case 'BASIC':
    case 'BEGINNER':
      return 'Basic';
    default:
      return 'Not specified';
  }
};

const levelRank = (value?: string): number => {
  switch (canonicalCandidateSkillLevel(value)) {
    case 'Expert':
      return 0;
    case 'Intermediate':
      return 1;
    case 'Basic':
      return 2;
    default:
      return 3;
  }
};

export const sortCandidateSummarySkills = (
  skills?: CandidateAiSummarySkill[]
): CandidateAiSummarySkill[] =>
  [...(skills || [])]
    .map((skill) => ({
      ...skill,
      level: canonicalCandidateSkillLevel(skill.level),
    }))
    .sort(
      (left, right) =>
        levelRank(left.level) - levelRank(right.level) ||
        left.skill.localeCompare(right.skill)
    );

export const candidateSummarySkillLevelColor = (
  level?: string
): 'blue' | 'cyan' | 'default' => {
  switch (canonicalCandidateSkillLevel(level)) {
    case 'Expert':
      return 'blue';
    case 'Intermediate':
      return 'cyan';
    default:
      return 'default';
  }
};
